// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function Vector102Icon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 353 411"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        opacity={".25"}
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M197.814.708c61.499 3.537 118.837 41.605 140.316 114.435 24.717 83.81 19.061 182.484-36.284 238.309-63.28 63.828-152.958 78.192-219.254 19.444C13.149 311.36-19.15 196.129 11.734 96.372 38.685 9.313 123.847-3.546 197.814.708z"
        }
        fill={"currentColor"}
      ></path>
    </svg>
  )
}

export default Vector102Icon
/* prettier-ignore-end */
